'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSucceededWithOperator = undefined;

var _asyncStatuses = require('../constants/asyncStatuses');

var _requestStateUpdate = require('./requestStateUpdate');

/**
 * Set status and operate on data when a request succeeds
 *
 * @param {Function} operator operator to apply to data
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
*/
var requestSucceededWithOperator = exports.requestSucceededWithOperator = (0, _requestStateUpdate.requestStateUpdate)(_asyncStatuses.SUCCEEDED);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/operators/requestSucceededWithOperator.js
// module id = 332
// module chunks = 2 3